export const TENANT_SUBSCRIPTION_CHANGED_EVENT =
  "tm-tenant-subscription-changed";

/**
 * @param {string} tenantId
 * @param {import('./tenant-subscription.js').TenantSubscription|null|undefined} [subscription]
 */
export function emitTenantSubscriptionChanged(tenantId, subscription) {
  if (typeof window === "undefined") return;
  try {
    window.dispatchEvent(
      new CustomEvent(TENANT_SUBSCRIPTION_CHANGED_EVENT, {
        detail: {
          tenantId: String(tenantId || "").trim(),
          subscription: subscription || null,
        },
      }),
    );
  } catch {
    /* noop */
  }
}
